export const versionUpdateData = [
  {
    version: '3.2.7',
    contents: `
    <ul>
      <li><strong>[기본 보드 구성 확장]</strong> 포스팅2, 포토카드2, 갤러리, 커플, 방명록2, TRPG, 스티커보드, 인터랙티브 스토리, 메모, 탐색, 레이드, 월드맵, 스레드, 퀘스트, 베팅 등 다양한 게시판 타입이 기본 구성에 추가되었습니다.</li>
      <li><strong>[커스텀 커서 활성화]</strong> 커스텀 커서 기능이 기본적으로 활성화됩니다.</li>
      <li><strong>[디데이 위젯 기본 활성화]</strong> 디데이 위젯이 기본으로 켜진 상태로 제공됩니다.</li>
      <li><strong>[신규 기능 기본 활성화]</strong> 슈팅스타, 챌린지, 채팅, 미니 메모 타입, 캘린더 스티커, 심지, 포토카드 히스토리, 펫 시스템, 전투 시스템, 드로잉툴이 기본 활성화됩니다.</li>
      <li><strong>[릴리즈 버전 갱신]</strong> ServiceFooter 표시 버전을 3.2.7로 올리고, 업데이트 목록을 최신화했습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.2.5',
    contents: `
    <ul>
      <li><strong>[Timeline 이미지 로딩 최적화]</strong> 해시태그 카운트 집계를 통합해 all 탭에서 중복 조회를 제거하고, 탭 전환 시 불필요한 서버 요청을 줄였습니다.</li>
      <li><strong>[실시간/폴링 중복 제거]</strong> 실시간 로드가 켜진 경우 30초 신규 글 폴링을 비활성화해 Firestore 요청과 렌더링 부하를 완화했습니다.</li>
      <li><strong>[설정 구독 상향 이동]</strong> Timeline 카드마다 반복되던 설정 문서 구독을 페이지 상위 1회 구독으로 변경해 초기 렌더 비용을 줄였습니다.</li>
      <li><strong>[깊은 페이지 이동 안정화]</strong> 페이징 커서 미스 시 대량 offset 조회 대신 페이지 단위 커서 누적 방식으로 바꿔 응답 지연을 완화했습니다.</li>
      <li><strong>[릴리즈 버전 갱신]</strong> ServiceFooter 표시 버전을 3.2.5로 올리고, 업데이트 목록을 최신화했습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.2.2',
    contents: `
    <ul>
      <li><strong>[테마 라우트 전환 안정화]</strong> 페이지 이동 시 이전 페이지의 커스텀 테마가 뒤늦게 적용되는 현상을 줄이기 위해 useSetTheme의 라우트 이탈 가드를 보강했습니다.</li>
      <li><strong>[포토카드 사이드 패널 전환 개선]</strong> 사이드 패널 토글 시 메인 이미지가 늘어났다 줄어들어 보이던 움직임을 제거하고, 레이아웃 이동만 부드럽게 동작하도록 구조를 개선했습니다.</li>
      <li><strong>[애니메이션 구조 정리]</strong> 포토카드 상세의 framer-motion layout 기반 전환을 단순화하고, SideWrapper를 CSS 기반 너비 트랜지션으로 전환해 시각적 흔들림을 완화했습니다.</li>
      <li><strong>[호환성 보완]</strong> 공통 SideWrapper 컴포넌트에 기본 열림 동작을 유지해 기존 사용처에서 타입/빌드 오류가 발생하지 않도록 보완했습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.2.1',
    contents: `
    <ul>
      <li><strong>[포토카드 스탠딩 대사 개선]</strong> 스탠딩 대사 오버레이가 ContentsWrap 레벨로 이동되어 말풍선이 뷰포트 기준으로 올바르게 표시됩니다. 멤버 권한 제한 없이 활성화 시 대사가 출력됩니다.</li>
      <li><strong>[이미지 클릭 비활성화]</strong> 스탠딩 대사가 활성화된 경우, 이미지 클릭 시 새 창 열기가 비활성화되고 대사가 출력됩니다.</li>
      <li><strong>[대문 게이트 로직 개선]</strong> 로그인 필요 게이트와 진입 버튼 게이트가 구분 처리됩니다. 로그인 필요 게이트는 localStorage 캐시를 무시하고 인증 여부만 체크합니다.</li>
      <li><strong>[로그아웃 시 게이트 캐시 초기화]</strong> 로그아웃/탈퇴 후 다시 방문하면 게이트 페이지가 다시 표시되도록 캐시가 초기화됩니다.</li>
      <li><strong>[정산 이벤트 아코디언 UI]</strong> 정산 이벤트 항목 헤더를 클릭하면 상세 내용을 펼치거나 접을 수 있습니다.</li>
      <li><strong>[정산 레이아웃 개선]</strong> 기본 보상/분기별 보상/출석 보상 섹션 간 구분선이 추가되고 레이아웃이 정리되었습니다.</li>
      <li><strong>[기타 버그 수정 및 UI 개선]</strong> 댓글 섹션 패딩 조정, 코드 포맷 정리 등 다양한 세부 개선이 반영되었습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.11',
    contents: `
    <ul>
      <li><strong>[퀘스트 생성 UX 개선]</strong> 퀘스트 만들기 모달의 필수 항목(제목/보상 이미지/보상 이름)을 명확히 표시하고, 조건 미충족 시 등록 버튼을 비활성화했습니다.</li>
      <li><strong>[퀘스트 타입 기본값 고정]</strong> 퀘스트 등록 시 기본 타입이 멤버 의뢰로 저장되도록 수정했습니다.</li>
      <li><strong>[관리자 알림 연동]</strong> 퀘스트 등록 완료 시 관리자 계정에 검토 요청 알림을 발송하고, 알림 클릭 시 퀘스트 관리의 멤버 의뢰 탭으로 바로 이동합니다.</li>
      <li><strong>[완료 피드백 변경]</strong> 등록 완료 모달 대신 알럿으로 안내하고, 등록 직후 생성 모달이 닫히도록 동선을 정리했습니다.</li>
      <li><strong>[퀘스트 편집 레이아웃 안정화]</strong> 기본설정 탭의 과도한 가로/세로 스크롤 및 에디터 영역 깨짐 현상을 완화했습니다.</li>
      <li><strong>[아이템 관리 화면 정리]</strong> 아이템 관리 페이지에서 아이템 목록 관리 섹션을 제거하고, 미사용 컴포넌트를 정리했습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.10',
    contents: `
    <ul>
      <li><strong>[포스팅 상세 X(트위터) 위젯 잘림 개선]</strong> DetailContents에서 X 임베드 하단이 잘리던 문제를 수정했습니다.</li>
      <li><strong>[X 임베드 저장 정규화]</strong> 포스팅 저장 시 임베드 HTML을 원본(blockquote + 링크) 형태로 정규화해 상세 페이지에서 안정적으로 재렌더링되도록 개선했습니다.</li>
      <li><strong>[PostingRow 편집 동선 보완]</strong> 링크형 포스팅에서도 수정/삭제가 가능하도록 Comment 아이콘 옆에 텍스트 버튼을 추가했습니다.</li>
      <li><strong>[빌드 안정화]</strong> 트위터 임베드 훅의 문법 오류를 수정해 컴파일 실패가 발생하지 않도록 보완했습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.9',
    contents: `
    <ul>
      <li><strong>[레이드 배너 개선]</strong> 레이드 상세 페이지에 예고·진행중·완료 상태에 따라 공지 배너가 표시됩니다. 구역명, 설명 텍스트가 어나운스먼트 바에 자동으로 출력됩니다.</li>
      <li><strong>[퀘스트 로그 상세]</strong> 퀘스트 로그 상세 페이지 및 로그 타임라인 UI가 개선되었습니다.</li>
      <li><strong>[스레드 선물/댓글접기]</strong> 스레드 작성 플로우 훅이 분리되고 선물하기 및 댓글 접기 기능이 추가되었습니다.</li>
      <li><strong>[스킬 기능 타입 확장]</strong> 스킬 기능 타입이 확장되고 결과 카드 테두리 이미지 설정이 개선되었습니다.</li>
      <li><strong>[정산 조건 체크]</strong> 정산 이벤트에 조건 확인 기능이 추가되어 레이드 클리어·캐릭터 HP 등의 조건을 설정할 수 있습니다.</li>
      <li><strong>[네비게이션 메뉴 이미지/레이아웃]</strong> 네비게이션 메뉴 항목에 이미지 및 레이아웃 옵션이 개선되었습니다.</li>
      <li><strong>[폼 TAGS 버그 수정]</strong> TAGS 필드 제출 시 HashtagTab에 태그가 추가되지 않던 버그가 수정되었습니다.</li>
      <li><strong>[방명록·타임라인·포토카드 UX 개선]</strong> 각 페이지의 사용성이 개선되고 다양한 버그가 수정되었습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.8',
    contents: `
    <ul>
      <li><strong>[타임라인 선물하기]</strong> 게시글 작성 시 대상 캐릭터에게 인벤토리 아이템을 선물할 수 있습니다. 선물 결과(보내는 이/받는 이/아이템/메시지)가 게시글에 표시됩니다.</li>
      <li><strong>[선물 결과 디자인 커스텀]</strong> 관리자 설정에서 선물 결과 카드의 배경색, 글자색, 테두리 이미지 등을 커스터마이징할 수 있습니다.</li>
      <li><strong>[가위바위보 도전장 모드]</strong> 타임라인 댓글에서 게시글 작성자에게 가위바위보 배틀을 도전할 수 있습니다. 결과가 댓글에 자동 표시됩니다.</li>
      <li><strong>[포토카드 스탠딩 대사 탭]</strong> 편집 모드에서 [스탠딩 대사] 탭이 추가됩니다. 옷장별로 표정·대사를 설정하고, 뷰 모드에서 클릭 시 또는 자동으로 대사가 말풍선으로 출력됩니다.</li>
      <li><strong>[이미지 핏 옵션]</strong> 포토카드 스탠딩 대사 탭에서 이미지 표시 방식을 '화면에 핏되게 리사이징' 또는 '원본 사이즈 출력' 중 선택할 수 있습니다.</li>
      <li><strong>[포토카드 편집 탭 썸네일]</strong> 편집 모드의 옷장 탭 메뉴에서도 등록된 썸네일 이미지가 표시됩니다.</li>
      <li><strong>[멤버 권한 추가]</strong> [캐릭터 스탠딩 설정 버튼], [스탠딩 대사 설정 탭] 두 항목이 멤버 권한 관리에 추가되었습니다.</li>
      <li><strong>[타임라인 기능 노출 조건]</strong> 선물하기·아이템 조합·조사하기·뽑기는 상점(Store) 게시판과 포토카드(Photocard) 게시판이 모두 활성화된 경우에만 노출됩니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.7',
    contents: `
    <ul>
      <li><strong>[뽑기 아이템 이미지 표시 개선]</strong> 뽑기 결과 카드에서 아이템 이미지가 표시되지 않던 문제가 수정되었습니다. 스킬 아이템도 올바르게 이미지가 표시됩니다.</li>
      <li><strong>[스킬 아이템 뽑기 지원]</strong> 뽑기 아이템 목록에 스킬 아이템이 포함된 경우, 정상적으로 뽑혀 캐릭터 인벤토리에 추가됩니다.</li>
      <li><strong>[타임라인 상세 페이지 개선]</strong> 게시글 상세 페이지에서 본문 이미지가 트위터처럼 본문과 함께 표시되며, 작성자 표시 유형 설정이 댓글에도 적용됩니다.</li>
      <li><strong>[스티커보드 캐릭터 연동 자동화]</strong> 게시판 관리에서 스티커보드에 캐릭터를 연동하면 해당 캐릭터의 마이룸도 자동으로 연결됩니다.</li>
      <li><strong>[선물 아이콘 표시 복구]</strong> 선물 받은 아이템에 선물 아이콘이 다시 표시됩니다.</li>
      <li><strong>[선물 아이템 판매가 0원]</strong> 선물 받은 아이템은 판매 가격이 항상 0G로 표시됩니다.</li>
      <li><strong>[조사 구역명 미설정 시 숨김]</strong> 조사 결과 카드에서 구역명이 '지역없음'인 경우 해당 항목이 표시되지 않습니다.</li>
      <li><strong>[아이템 목록 스크롤 UI 개선]</strong> 상점 아이템 목록 하단이 부드럽게 사라지는 그라디언트 효과가 추가되었습니다.</li>
    </ul>
  `,
  },
  {
    version: '2.7.2',
    contents: `
  <ul>
  <li>디데이 위젯 레이아웃 옵션 추가 </li>
        <li>캘린더형에 [일간/주간/월간/챌린지] 레이아웃이 변경되었습니다.</li> 
        <li>웹페이지 내 알림 시스템이 개선되었습니다. 브라우저 알림을 허용해주세요. 알림과 디엠 메시지 도착 시 알림음이 울립니다.</li>
        <li>메모형에 별점기능이 추가되었습니다.</li>\
      </ul>
    `,
  },
  {
    version: '2.6.6',
    contents: `
      <ul>
        <li>이번 업데이트 내용: 브라우저 알림을 허용해주세요. 알림과 디엠 메시지 도착 시 알림음이 울립니다.</li>
        <li>웹페이지 내 알림 시스템이 개선되었습니다.</li>
        <li>사용자 경험 향상을 위한 다양한 기능이 추가되었습니다.</li>
      </ul>
    `,
  },
  {
    version: '2.7.3',
    contents: `
    <ul>
      <li>에디터 html토글 가능 </li>
        <li>인벤토리 아이템 기능에 따라 분류 가능</li> 
        <li>타임라인형 게시판 youtube 영상 별도 추가 가능</li>
        <li>게시판 공통 : 태그 탭에서 스크롤 영역 발생 시 화살표 버튼 생성</li>
      </ul>
    `,
  },
  {
    version: '2.7.4',
    contents: `
    <ul>
      <li>TPRG형 html 편집 개선 및 세션로그 백업 개선</li>
      <li>모든 게시글 삭제 기능 [홈페이지 설정]-[위험구역]</li>
    </ul>
  `,
  },
  {
    version: '2.7.5',
    contents: `
    <ul>
      <li>[html모드 개선]html모드가 일반 에디터와 분리됩니다.</li>
      <li>폰트가 일부 추가되었습니다.</li>
      <li>버튼 테두리 이미지 설정이 가능합니다.</li>
      <li>타임라인형 [반응] 이모티콘 ui가 개선되었습니다.</li>
    </ul>
  `,
  },
  {
    version: '2.7.6',
    contents: `
    <ul>
      <li>다양한 버그 개선</li>
    </ul>
  `,
  },
  {
    version: '2.7.7',
    contents: `
    <ul>
      <li>[브라우저 알림] 유저 Id가 아닌 닉네임 표시, 2중알림 개선 (댓글 작성 시, 댓글알림만 전송)</li>
      <li>- [캘린더형]
    - 스티커보드 아이템에 커스텀 링크 설정
    - 미니 캘린더 모바일 최적화
    - 텍스트박스 입력 크기 수정</li>
    <li>[내 캐릭터] 섹션에서 대표 캐릭터 지정 가능</li>
    <li>[폰트 컬러] 바깥으로 마우스 나올 시, 스크롤 맨 위로 올라가는 현상 수정</li>
    <li>[들여쓰기]시, 맨 첫 문단만 들여쓰기</li>
    </ul>
  `,
  },
  {
    version: '2.8.0',
    contents: `
    <ul>
      <li>포토카드형 신규 디자인 추가 </li>
      <li>[메뉴 레이아웃 - 메뉴 목록] 마우스 hover이미지 / 모바일 이미지 설정 가능</li>
      <li>[메뉴 레이아웃 - 서브 메뉴] 서브메뉴 설정 기능 추가</li>
    </ul>
  `,
  },
  {
    version: '3.0.2',
    contents: `
    <ul>
      <li>Game ui형 및 다양한 커뮤니티 기능 추가</li>
      <li>다양한 버그 개선</li>
      <li>타임라인형 댓글 로딩 개선</li>
      <li>각 유저별 재화 히스토리 기능 추가</li>
    </ul>
  `,
  },
  {
    version: '3.0.4',
    contents: `
    <ul>
      <li>멤버 관리 벌크 엑션 추가</li>
      <li>멤버 권한일 시 역할 부여 기능 추가 (스텝 등)</li>
      <li>커스텀 폰트 관리 기능 추가</li>
      <li>기타 버그 수정</li>
    </ul>
  `,
  },
  {
    version: '3.0.5',
    contents: `
    <ul>
      <li>배너 그룹 관리 추가 - 기존 배너 마이그레이션 가능</li>
      <li>포토카드형 bgm출력 에러 수정</li>
      <li>커스텀 디자인 편집 섹션 개선</li>
      <li>기타 버그 수정</li>
    </ul>
  `,
  },
  {
    version: '3.0.6',
    contents: `
    <ul>
      <li>갤러리: 연도별/월별/메이슨리 뷰 추가 및 월 클릭 시 디테일 리스트 전환, 뒤로가기 지원</li>
      <li>갤러리 카드: contentHeight 커스텀 반영, 썸네일/오버레이 개선</li>
      <li>업로드: MultiUpload 드래그&드롭, 높이 확장, 공통 제목/날짜 입력, 모달 내 "여러장 개별 추가" 버튼으로 대량 업로드 지원</li>
      <li>기타 안정화 및 UI 개선</li>
    </ul>
  `,
  },
  {
    version: '3.0.7',
    contents: `
    <ul>
      <li><strong>시리즈 페이지 디자인 개선:</strong> 썸네일 배경, 설명 추가, 정렬 옵션, 표시/숨김 설정</li>
      <li><strong>플로팅 채팅:</strong> 채널톡 스타일 플로팅 창, 오른쪽 하단 표시, 모바일 최적화</li>
      <li><strong>로그 시리즈 패널:</strong> 포토카드 LOG 탭 클릭 시 슬라이드 패널로 시리즈 목록 보기</li>
      <li><strong>디자인 설정 통합:</strong> 배경/폰트/버튼/카드/컬러/로딩을 탭으로 통합</li>
      <li><strong>로딩 커스터마이징:</strong> 6가지 로딩 디자인 선택, 텍스트/색상 설정</li>
      <li><strong>스티커보드 크기 조절:</strong> 4개 모서리 핸들로 자유롭게 크기 조절, 자동 저장</li>
      <li><strong>WebGL 배경:</strong> Unicorn Studio 프리셋 관리 시스템</li>
      <li><strong>배경 그라디언트:</strong> 2색 그라디언트 + 방향 설정</li>
      <li>메인 홈 항목 중 '데일리 투두 리스트' 추가. 로컬에 저장되는 투두리스트</li>
    </ul>
  `,
  },
  {
    version: '3.0.9',
    contents: `
    <ul>
      <li><strong>시리즈 페이지 디자인 개선:</strong> 썸네일 배경, 설명 추가, 정렬 옵션, 표시/숨김 설정</li>
      <li><strong>플로팅 채팅:</strong> 채널톡 스타일 플로팅 창, 오른쪽 하단 표시, 모바일 최적화</li>
      <li><strong>로그 시리즈 패널:</strong> 포토카드 LOG 탭 클릭 시 슬라이드 패널로 시리즈 목록 보기</li>
      <li><strong>로딩 커스터마이징:</strong> 6가지 로딩 디자인 선택, 텍스트/색상 설정</li>
      <li><strong>스티커보드 크기 조절:</strong> 4개 모서리 핸들로 자유롭게 크기 조절, 자동 저장</li>
      <li><strong>WebGL 배경:</strong> Unicorn Studio 프리셋 관리 시스템</li>
      <li><strong>배경 그라디언트:</strong> 2색 그라디언트 + 방향 설정</li>
      <li>메인 홈 항목 중 '데일리 투두 리스트' 추가. 로컬에 저장되는 투두리스트</li>
     <li><strong>[정산 페이지] 일일 출석 기능 추가</strong></li>
      <li><strong>[포토카드] 개별 탭 설정 기능</strong></li>
      <li>- '이 탭 구성 & 디자인' 모달에서 탭 이름/이미지/활성화 설정</li>
      <li><strong>[채팅형 방명록] 신규 기능 추가</strong></li>
      <li><strong>[미니 방명록] UI 개선</strong></li>
    </ul>
  `,
  },
  {
    version: '3.0.10',
    contents: `
    <ul>
      <li><strong>[스티커보드 관리 개선]</strong> 테이블 UI로 개선, 게시글 관리자(오너) 및 연동된 캐릭터 표시</li>
      <li><strong>[스티커보드 캐릭터 연동]</strong> 스티커보드에 캐릭터 연동 기능 추가</li>
      <li><strong>[스티커보드 설정 이동]</strong> 스티커보드 게시판 관리가 [홈페이지 설정] → [게시판별 기능]으로 이동</li>
      <li><strong>[프로필 관리 권한]</strong> 멤버의 프로필(캐릭터) 추가 권한 관리 기능 추가</li>
    </ul>
  `,
  },
  {
    version: '3.0.11',
    contents: `
    <ul>
      <li><strong>[WorldMap 개선]</strong> 좌표 설정 기능 추가 및 보상 섹션(RewardSection) 컴포넌트 개선</li>
      <li><strong>[검색 기능 개선]</strong> 검색 에러 처리 로직 추가</li>
      <li><strong>[캘린더 버그 수정]</strong> 연속일정 표시 버그 수정</li>
      <li><strong>[상점 레이아웃]</strong> 레이아웃 선택 기능 추가 및 기본형 레이아웃 구현</li>
      <li><strong>[상점 태그 필터링]</strong> 태그 필터링 및 아이템 목록 표시 개선</li>
      <li><strong>[Timeline 개선]</strong> 실시간 로드 옵션 개선 - 수정/삭제 시 항상 반영</li>
      <li><strong>[CharacterPanel]</strong> 로그아웃 상태에서 캐릭터 없음 섹션 표시 개선</li>
      <li><strong>[메인 공지]</strong> HTML 모드 렌더링 개선</li>
      <li><strong>[HashtagTab]</strong> 빈 경로 에러 수정</li>
      <li><strong>[배경 설정]</strong> 초기 렌더링 및 useEffect 최적화</li>
      <li><strong>[미니 방명록]</strong> accessType 필터링 및 연동 게시판 설정 개선</li>
    </ul>
  `,
  },
  {
    version: '3.1.1',
    contents: `
    <ul>
      <li><strong>[대문 페이지 개선]</strong> 한 번 입장하면 다시 방문해도 대문 페이지가 뜨지 않습니다. 로그인 완료 후 바로 메인 페이지로 이동합니다.</li>
      <li><strong>[조사 텍스트 관리]</strong> '지역없음' 옵션이 추가되었습니다. 특정 지역에 속하지 않는 조사 지문을 등록할 수 있습니다.</li>
      <li><strong>[조사하기 기능]</strong> 탐색 지역이 없어도 '지역없음'으로 조사를 진행할 수 있습니다.</li>
      <li><strong>[조사 결과 표시]</strong> 조사 완료 시 획득한 아이템이 결과 카드에 함께 표시됩니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.2',
    contents: `
    <ul>
      <li><strong>[커스텀 봇]</strong> 객체 타입 결과값 렌더링 오류 수정</li>
      <li><strong>[해시태그]</strong> '표시 안함' 옵션에서 페이지가 뜨지 않는 버그 수정</li>
      <li><strong>[갤러리]</strong> 이미지 로딩 시 스켈레톤 UI 추가</li>
      <li><strong>[작성자 표시]</strong> '캐릭터[작성자]' 옵션 추가</li>
    </ul>
  `,
  },
  {
    version: '3.1.3',
    contents: `
    <ul>
      <li><strong>[화살표 버튼 디자인]</strong> 화살표 버튼 디자인을 6종 중 선택할 수 있습니다. (다이아 애로우, 서클 애로우, 슬라이드 애로우, 룬 애로우, 픽셀 애로우, 크리스탈 애로우)</li>
      <li><strong>[디자인 설정]</strong> [화살표 버튼] 탭이 추가되어 버튼 컬러, 포인트 컬러, 배경 컬러를 설정할 수 있습니다.</li>
      <li><strong>[화살표 버튼 통합]</strong> 뒤로가기 버튼, 슬라이더, 갤러리 등 홈페이지 전반의 화살표 버튼에 동일한 디자인이 적용됩니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.4',
    contents: `
    <ul>
      <li><strong>[타임라인 새 창 열기]</strong> 게시글 이미지를 클릭하면 새 창에서 상세 페이지가 열리는 옵션이 추가되었습니다.</li>
      <li><strong>[댓글 글자수 표시/제한]</strong> 댓글 작성 시 글자수를 확인할 수 있고, 최대 글자수를 설정할 수 있습니다.</li>
      <li><strong>[캐릭터 패널 개선]</strong> 버튼에 마우스를 올리면 은은한 빛남 효과가 적용됩니다. 대표 캐릭터가 없으면 안내 메시지가 표시됩니다.</li>
      <li><strong>[대표 폼 프로필 연동]</strong> 대표 폼을 설정한 경우, 작성자 이름 클릭 시 폼 상세 페이지로 이동할 수 있습니다.</li>
      <li><strong>[세계관 메뉴 링크]</strong> 세계관 탭 메뉴에 외부 링크를 연결하면 클릭 시 해당 링크로 이동합니다.</li>
      <li><strong>[탐색 보상 개선]</strong> 전투 기능이 꺼져 있으면 전투 확률이 자동으로 0%로 처리됩니다.</li>
      <li><strong>[폼 게시판 수정]</strong> 폼 삭제 시 게시글 목록에 빈 항목이 남는 문제가 수정되었습니다.</li>
      <li><strong>[전투 로그 개선]</strong> 탐색 전투 로그가 더 깔끔하게 표시되며, 턴 번호가 함께 나타납니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.6',
    contents: `
    <ul>
      <li><strong>[스레드 업로드 기능 확장]</strong> 스레드 게시글 작성 시 조사하기, 민감 정보 표시, 뽑기 아이템, 아이템 조합 기능을 사용할 수 있습니다. 각 기능은 스레드 설정에서 활성화할 수 있습니다.</li>
      <li><strong>[스레드 결과물 표시]</strong> 조사 결과, 뽑기 아이템 결과, 아이템 조합 섹션이 스레드 게시글 목록에서 타임라인 게시판과 동일하게 표시됩니다.</li>
      <li><strong>[민감 정보 / 긴 이미지 접기]</strong> 스레드 게시글의 민감 정보 이미지 가림 및 긴 이미지 접기 기능이 실제 데이터로 반영됩니다.</li>
      <li><strong>[스레드 끌어올리기 개선]</strong> 끌어올리기 취소 시 게시글이 원래 위치로 복원되고, 아이콘 컬러가 끌어올린 상태에 따라 변경됩니다.</li>
      <li><strong>[스레드 태그 탭]</strong> 태그 탭 클릭 시 해시태그 목록이 토글되며, 태그 클릭 시 해당 태그의 게시글만 필터링됩니다.</li>
      <li><strong>[스레드 북마크 토글]</strong> 북마크 클릭 시 실시간으로 상태가 반영되며, 다시 클릭하면 북마크가 해제됩니다.</li>
      <li><strong>[스레드 삭제/수정 실시간 반영]</strong> 게시글 삭제 또는 수정 시 목록에 즉시 반영됩니다.</li>
      <li><strong>[최근 언급 지우기]</strong> 스레드 최근 언급 섹션에 모두 지우기 버튼이 추가되었습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.1.5',
    contents: `
    <ul>
      <li><strong>[스레드 조사/수정 개선]</strong> 스레드 업로드의 조사하기 결과 저장/표시를 안정화하고, 수정 모달에서 기존 데이터를 안전하게 불러오도록 개선했습니다.</li>
      <li><strong>[스레드 타래 표시 개선]</strong> 내 글에 단 자기답글(타래)은 본문 아래 체인으로 연결되며, 메인 목록 중복 노출을 방지하고 연결선 간격을 정리했습니다.</li>
      <li><strong>[최신글 끌어올림]</strong> 내 게시글에 타래를 달면 원본 스레드가 최신글 기준으로 위로 올라오도록 정렬 동작을 개선했습니다.</li>
      <li><strong>[북마크/액션바 UI 개선]</strong> 북마크 상태 아이콘 표시를 고도화하고, 리포스트/인용/캡처 아이콘을 신규 SVG로 교체했습니다.</li>
      <li><strong>[스레드 상세 구조 개선]</strong> 본문과 댓글 영역을 분리하고, 댓글 체인을 단계적으로 보여주는 방식으로 상세 페이지 가독성을 높였습니다.</li>
    </ul>
  `,
  },
  {
    version: '3.2.6',
    contents: `
    <ul>
      <li><strong>[기본 보드 구성 정리]</strong> 신규 홈페이지를 시작할 때 기본으로 노출되는 게시판 구성이 더 간결하게 정리되었습니다.</li>
      <li><strong>[기본 기능 토글 조정]</strong> 위젯/효과/보조 기능의 기본값이 실제 사용 흐름에 맞게 재조정되어 초기 세팅이 더 안정적으로 시작됩니다.</li>
      <li><strong>[초기 설정 사용성 개선]</strong> 홈페이지 기본 설정에서 불필요한 옵션 과노출을 줄여, 첫 설정 시 필요한 항목에 더 쉽게 집중할 수 있습니다.</li>
    </ul>
  `,
  },
];
